import React, { useState, useEffect } from "react";
import { Banner, Layout, Button, Text, BlockStack, Modal } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import { getWithExpiry, deleteObject } from "../../utils/LocalStorageExpiry";
import { SaleTypes, getSaleTypeUrlParam } from "../../features/DiscountPlanning/Discount";

export default function DraftResumeBanner() {
  const [draft, setDraft] = useState(null);
  const [isUpgradeFlow, setIsUpgradeFlow] = useState(false);
  const navigate = useNavigate();
  const draftKey = "discoDiscountDraft";
  const upgradeKey = "discoDuringUpgrade";

  useEffect(() => {
    try {
      const savedDraft = getWithExpiry(draftKey);
      if (savedDraft) {
        setDraft(savedDraft);
        const duringUpgrade = localStorage.getItem(upgradeKey);
        if (duringUpgrade === "true") {
           setIsUpgradeFlow(true);
           localStorage.removeItem(upgradeKey);
        }
      }
    } catch (e) {
      console.error("Error reading draft", e);
    }
  }, []);

  if (!draft) return null;

  const handleResume = () => {
    const saleType = draft.discount?.saleType || SaleTypes.SameDiscount;
    const urlParam = getSaleTypeUrlParam(saleType);
    
    navigate(`/campaigns/create/${urlParam}`, { state: { autoLoadDraft: true } });
  };

  const handleDiscard = () => {
    deleteObject(draftKey);
    setDraft(null);
    setIsUpgradeFlow(false);
  };

  const dateStr = draft.created ? new Date(draft.created).toLocaleDateString() : "";

  if (isUpgradeFlow) {
    return (
      <Modal
        open={true}
        onClose={() => setIsUpgradeFlow(false)}
        title="Welcome back!"
        primaryAction={{
            content: "Resume campaign",
            onAction: handleResume,
        }}
        secondaryActions={[
            {
                content: "Discard draft",
                onAction: handleDiscard,
            }
        ]}
      >
        <Modal.Section>
            <Text as="p">
                You were in the middle of creating a campaign before upgrading. 
                We saved your progress so you can continue exactly where you left off.
            </Text>
        </Modal.Section>
      </Modal>
    );
  }

  return (
    <Layout.Section>
      <Banner
        title="Unfinished campaign found"
        tone="info"
        onDismiss={handleDiscard}
      >
        <BlockStack gap="400">
          <Text as="p">
            You have an unsaved campaign draft{dateStr ? ` from ${dateStr}` : ""}. 
            Would you like to continue where you left off?
          </Text>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button variant="primary" onClick={handleResume}>
              Resume campaign
            </Button>
            <Button onClick={handleDiscard}>
              Discard
            </Button>
          </div>
        </BlockStack>
      </Banner>
    </Layout.Section>
  );
}
